export const getFinancialYear = (date = new Date()) => {
    const month = date.getMonth() + 1; // getMonth() is 0-indexed
    const year = date.getFullYear();

    return month >= 4 ? year : year - 1;
};
